import React from 'react';

import { 
	func, array, 
} from 'prop-types';

const MAX_RECIPE_COUNT = process.env.REACT_APP_MAX_RECIPE_COUNT || 999;

export default class Container extends React.PureComponent {
    static propTypes = {
    	render : func.isRequired,
    	recipes : array.isRequired,
    }
    constructor(props){
    	super(props);
    	const showHelp = JSON.parse(localStorage.getItem('recipeList.showHelp')) || true;
    	this.state={
    		showHelp
    	};
    }
    render(){
    	const {render,recipes,...other} = this.props;
    	const enableCreating = MAX_RECIPE_COUNT > recipes.length;
    	return render({
    		showHelp : this.state.showHelp,
    		toggleShowHelp : (show)=>()=>{
    			localStorage.setItem('recipeList.showHelp', JSON.stringify(show));
    			this.setState({
    				showHelp : show
    			});
    		},
    		recipes,
    		enableCreating
    	},other);
    }
}